<template>
<div>
  <div class="my-account">
    <div class="wrapper">
      <div style="border-style:solid; border-width:1px; border-color:#a35608;padding:0.36rem 0 0.05rem 0;width:95%;margin:0 auto;border-radius:0.2rem">
            <div style="font-size:0.35rem;color:#a35608;margin-left:0.3rem">当前管理员可操作以下功能：</div>
            <div class="nav acea-row row-middle">
              <div class="item" @click="showWin = 1">
                <div class="pictrue"><img src="@assets/images/simiao.png" /></div>
                <div>添加寺院</div>
              </div>
              <!-- <div class="item" >
                <div class="pictrue"><img src="@assets/images/sendadmin.png" /></div>
                <div>授权管理</div>
              </div> -->
            </div>
      </div> 
    </div>

    <div class="wrapper" style="padding-left:0.3rem;color:#a35608;" v-for="(item, index) in categoryList" :key="index">
        <table style="width:95%" >
            <tr>
                <td @click="cateNameInfo(item)">
                    {{item.cateName}}
                </td>
                <td align="right">
                    <button type="button" @click="confirmUserGrant(item)" style="border-style:solid; border-width:1px; border-color:#a35608;border-radius:0.16rem;height:0.75rem;width:2.2rem">
                    授权管理员
                    </button>
                </td>
            </tr>
        </table>
    </div>
    <div class="center" v-if="showWin==1">
        <div class="centerdiv">寺庙名称：
            <input
              type="text"
              placeholder="请填写寺庙名称"
              style="padding-left:0.3rem;color:#f8e006;height:0.75rem;border-radius:0.1rem;border-color:#f8e006;border-style:solid; border-width:1px;"
              v-model="cateName"
            />
        </div>
        <div class="buttonDiv">
            <div @click="showWin = 0" class="buttonStyle">
              取消
            </div>
            <div  @click="addCategoryConfirm" class="buttonStyle">
              确定
            </div>
        </div>
    </div>
  </div>
</div>
</template>
<script>
// import Recommend from "@components/Recommend";
// import { getBalance } from "../../api/user";
// import { queryDevice,device,deviceTiming } from "../../api/lamp";
// import lazhu from '@assets/images/lazhu1.png'
// import lazhusingle from '@assets/images/lazhusingle.png'

// import initData from '@/mixins/crud'
// import VueTimepicker from 'vue2-timepicker'
// CSS
// import 'vue2-timepicker/dist/VueTimepicker.css'

// import Datepicker from 'vuejs-datepicker';
// import {zh} from 'vuejs-datepicker/dist/locale'


// import { Picker } from 'vant'

import { getCategoryAll,addCategory } from "@api/store";
import { mapGetters } from "vuex";

export default {
  name: "SystemSet",
  components: {
  },
  props: {},
  data: function() {
//  const customFieldName = {
//       text: 'cateName',
//       values: 'id',
//     };
    return {
        categoryList:[],
        showWin:0,
        cateName: ""
    };
  },
  computed: mapGetters(["userInfo","isLogin"]),
  mounted: function() {
    this.getCategoryAll();
  },
  methods: {
    checkIsLogin(){
      const isLogin = this.isLogin;
      if (!isLogin) return toLogin();
    },
    getUserInfo(){
          this.$store.dispatch("USERINFO").then((res) => {
                this.adminid=res.adminid
          });
    },
    getCategoryAll(){
        getCategoryAll().then(
          res => {
            this.categoryList = res.data;
          },
          err => {
            that.$dialog.message(err.msg);
          }
        );
    },
    addCategoryConfirm(){
        addCategory({
            cateName:this.cateName
        }).then(
          res => {
            this.$dialog.message("添加成功");
            this.showWin = 0;
            this.getCategoryAll()
          },
          err => {
            this.$dialog.message(err.msg);
          }
        );
    },
    confirmUserGrant(item){
        this.$router.push({
          path: '/user/adminUser',
          query: {
            cateId: item.id,
            cateName: item.cateName
          }
        })
    },
    cateNameInfo(item){
        this.$router.push({
          path: '/user/merchantDevice',
          query: {
            cateId: item.id
          }
        })
    }
  }
};
</script>
<style scoped>
.checked{
  background: #f78817;
 }

.center {
  width:95%; 
  height:3rem; 
  z-index:99; 
  top: 3rem;
  background-color:#a35608;
  position: fixed;
  left: 0;
  right: 0;
  margin:0 auto;
  border-radius:0.16rem;
}
.centerdiv {
  font-size:0.35rem;
  margin-top:0.4rem;
  margin-left:0.4rem;
  color:#f8e006;
}
.selectdiv {
  margin-left:0.2rem;
  background-color:red;
  border-radius:0.16rem;
}
.buttonStyle {
  float:left;
  text-align:center;
  line-height: 0.75rem;
  margin-right:0.5rem;
  border-style:solid;
  border-width:1px; 
  border-color:#f8e006;
  border-radius:0.16rem;
  height:0.75rem;
  width:1.2rem
}
.buttonDiv {
  font-size:0.35rem;
  margin-top:0.5rem;
  margin-left:0.4rem;
  color:#f8e006;
  float:right;
}


 </style>
